import { render } from "./ContentMedia.vue?vue&type=template&id=7c5c0994&scoped=true&ts=true"
import script from "./ContentMedia.vue?vue&type=script&lang=ts"
export * from "./ContentMedia.vue?vue&type=script&lang=ts"

import "./ContentMedia.vue?vue&type=style&index=0&id=7c5c0994&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5c0994"]])

export default __exports__